@import 'vars';

$avatar-size--small: 30px;
$avatar-size--medium: 40px;
$avatar-size--large: 60px;
$avatar-size--xlarge: 80px;
$status-border--small: 3px;
$status-border: 4px;
$tooltip-max-width: 500px;

.avatar {
  background: $mid-grey;
  color: $dark-grey;
  border-radius: 50%;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  user-select: none;

  &--small {
    min-height: $avatar-size--small;
    width: $avatar-size--small;
  }

  &--medium {
    min-height: $avatar-size--medium;
    width: $avatar-size--medium;
  }

  &--large {
    min-height: $avatar-size--large;
    width: $avatar-size--large;
  }

  &--xlarge {
    min-height: $avatar-size--xlarge;
    width: $avatar-size--xlarge;
  }

  &--clickable {
    cursor: pointer;
  }

  &__initials {
    letter-spacing: 1px;
    color: $dark-blue;
    font-weight: $font-weight-black;

    &--small {
      font-size: $font-size-extra-small !important;
    }

    &--medium {
      font-size: $font-size-small;
    }

    &--large {
      font-size: $font-size-extra-large-softphone;
    }

    &--xlarge {
      font-size: $font-size-hero;
    }
  }

  &__tooltip {
    border-radius: 50%;
    position: absolute;
    background-color: white;
    top: -1px;
    right: -1px;
    display: flex;
    justify-content: center;
    align-items: center;

    > svg {
      width: 70% !important;
      height: 70% !important;
    }

    &__arrow {
      color: $white !important;

      &::before {
        border: 1px solid $mid-grey;
      }
    }
  }

  &__status-dot {
    border-radius: 50%;
    position: absolute;
    bottom: -2px;
    right: -2px;
    border: $status-border solid $white;

    &--small {
      border-width: $status-border--small;
      bottom: -3px;
      right: -3px;
    }

    &--outline {
      &::after {
        content: '';
        left: 0;
        top: 0;
        border-radius: 50%;
        position: absolute;
        height: 100%;
        width: 100%;
        border: 1px solid $dark-grey;
      }
    }
  }

  &-tooltip-container {
    max-width: $tooltip-max-width !important;
  }
}
